export type Shop = {
  code: string;
  name: string;
  flag: string;
  domain: string;
};

// 27 EU member-state shops + Switzerland — flag emoji + tamaris.com TLD/path.
// Real data is currently only seeded for IT and CH; the rest are placeholders
// for the multi-tenant aggregation UI.
export const SHOPS: readonly Shop[] = [
  { code: 'DE', name: 'Deutschland', flag: '🇩🇪', domain: 'tamaris.com/de' },
  { code: 'AT', name: 'Österreich', flag: '🇦🇹', domain: 'tamaris.com/at' },
  { code: 'CH', name: 'Schweiz', flag: '🇨🇭', domain: 'tamaris.com/ch' },
  { code: 'IT', name: 'Italien', flag: '🇮🇹', domain: 'tamaris.com/it' },
  { code: 'FR', name: 'Frankreich', flag: '🇫🇷', domain: 'tamaris.com/fr' },
  { code: 'ES', name: 'Spanien', flag: '🇪🇸', domain: 'tamaris.com/es' },
  { code: 'PT', name: 'Portugal', flag: '🇵🇹', domain: 'tamaris.com/pt' },
  { code: 'NL', name: 'Niederlande', flag: '🇳🇱', domain: 'tamaris.com/nl' },
  { code: 'BE', name: 'Belgien', flag: '🇧🇪', domain: 'tamaris.com/be' },
  { code: 'LU', name: 'Luxemburg', flag: '🇱🇺', domain: 'tamaris.com/lu' },
  { code: 'IE', name: 'Irland', flag: '🇮🇪', domain: 'tamaris.com/ie' },
  { code: 'DK', name: 'Dänemark', flag: '🇩🇰', domain: 'tamaris.com/dk' },
  { code: 'SE', name: 'Schweden', flag: '🇸🇪', domain: 'tamaris.com/se' },
  { code: 'FI', name: 'Finnland', flag: '🇫🇮', domain: 'tamaris.com/fi' },
  { code: 'PL', name: 'Polen', flag: '🇵🇱', domain: 'tamaris.com/pl' },
  { code: 'CZ', name: 'Tschechien', flag: '🇨🇿', domain: 'tamaris.com/cz' },
  { code: 'SK', name: 'Slowakei', flag: '🇸🇰', domain: 'tamaris.com/sk' },
  { code: 'HU', name: 'Ungarn', flag: '🇭🇺', domain: 'tamaris.com/hu' },
  { code: 'RO', name: 'Rumänien', flag: '🇷🇴', domain: 'tamaris.com/ro' },
  { code: 'BG', name: 'Bulgarien', flag: '🇧🇬', domain: 'tamaris.com/bg' },
  { code: 'GR', name: 'Griechenland', flag: '🇬🇷', domain: 'tamaris.com/gr' },
  { code: 'HR', name: 'Kroatien', flag: '🇭🇷', domain: 'tamaris.com/hr' },
  { code: 'SI', name: 'Slowenien', flag: '🇸🇮', domain: 'tamaris.com/si' },
  { code: 'EE', name: 'Estland', flag: '🇪🇪', domain: 'tamaris.com/ee' },
  { code: 'LV', name: 'Lettland', flag: '🇱🇻', domain: 'tamaris.com/lv' },
  { code: 'LT', name: 'Litauen', flag: '🇱🇹', domain: 'tamaris.com/lt' },
  { code: 'CY', name: 'Zypern', flag: '🇨🇾', domain: 'tamaris.com/cy' },
  { code: 'MT', name: 'Malta', flag: '🇲🇹', domain: 'tamaris.com/mt' },
];

export function findShop(code: string): Shop | undefined {
  return SHOPS.find((s) => s.code === code);
}
